<!-- Main Content - Hidden when create form is shown -->
<app-card [showHeader]="false" [padding]="0" [style.display]="!showCreate ? '' : 'none'">
  <div class="row p-t-25">
    <!-- Page Tools Row -->
    <div class="p-b-15">
      <app-base-page-tools
        [service]="serviceInstance"
        [fieldsConfigService]="fieldsConfigService"
        [canCreate]="canCreate"
        [availableViews]="getAvailableViews()"
        [currentView]="currentView"
        (viewModeChange)="setViewMode($event)">
      </app-base-page-tools>
    </div>

    <!-- Criteria Section -->
    <div class="p-b-15">
      <app-base-criteria>
        <ng-content select="[criteria]"></ng-content>
      </app-base-criteria>
    </div>

    <!-- Views Container -->
    @if (permissions?.access) {
      <div class="col-12">
        <div class="views-container" padding="0">
          <!-- Grid View (default) -->
          @if (currentView === 'grid') {
            <div class="grid-view p-b-15">
              <app-base-grid
                [canEdit]="canEdit"
                [canDelete]="canDelete"
                [service]="serviceInstance"
                [fieldsConfigService]="fieldsConfigService"
                [formComponent]="formComponent"
                [disableActionsFieldName]="disableActionsFieldName"
                [disableActionsValue]="disableActionsValue"
                [disableDeleteFieldName]="disableDeleteFieldName"
                [disableDeleteValue]="disableDeleteValue">
              </app-base-grid>
            </div>
          }

          <!-- Cards View -->
          @if (currentView === 'cards') {
            <div class="cards-view p-b-15">
              <app-base-cards
                [service]="serviceInstance"
                [menuId]="systemMenuId"
                [canEdit]="canEdit"
                [canDelete]="canDelete"
                [disableActionsFieldName]="disableActionsFieldName"
                [disableActionsValue]="disableActionsValue"
                [disableDeleteFieldName]="disableDeleteFieldName"
                [disableDeleteValue]="disableDeleteValue"
                (editClick)="editItem($event)"
                (deleteClick)="deleteItem($event)"
                (itemClick)="editItem($event)">
              </app-base-cards>
            </div>
          }

          <!-- Map View -->
          @if (currentView === 'map') {
            <div class="map-view p-b-15">
              @if (viewLoading) {
                <div class="loading-container">
                  <mat-spinner diameter="40"></mat-spinner>
                  <span class="loading-text">{{ 'loading' | translate }}...</span>
                </div>
              } @else if (mapTemplate) {
                <ng-container
                  *ngTemplateOutlet="mapTemplate; context: { $implicit: gridData, data: gridData, totalCount: totalCount }">
                </ng-container>
              } @else {
                <!-- Default Map Placeholder -->
                <div class="map-placeholder">
                  <mat-icon class="map-icon">map</mat-icon>
                  <p class="map-text">{{ 'mapViewNotConfigured' | translate }}</p>
                  <p class="map-hint">{{ 'provideMapTemplate' | translate }}</p>
                </div>
              }
            </div>
          }

        </div>
      </div>
    }
  </div>
</app-card>

<!-- Create/Edit Form - Shown when showCreate is true -->
<div [style.display]="showCreate ? '' : 'none'">
  <app-base-create
    [service]="serviceInstance"
    [fieldsConfigService]="fieldsConfigService"
    [canCreate]="canCreate"
    [canEdit]="canEdit">
    <ng-content select="[form]"></ng-content>
  </app-base-create>
</div>
